module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"jurisdiction-other-placeholder":"Préciser la juridiction"},"en":{"jurisdiction-other-placeholder":"Specify jurisdiction"}}')
  delete Component.options._Ctor
}
